/**
 * Filter operators for search / list API (field:operator:value).
 * Delegates to conditionBuilderUtils so operators stay aligned with ConditionRow.
 */

import { getOperatorsForField, isNumericDataType } from './conditionBuilderUtils';

export { NUMERIC_DATA_TYPES, isNumericDataType } from './conditionBuilderUtils';

export function getOperatorsForDataType(dataType) {
  return getOperatorsForField({ data_type: dataType });
}

export function defaultOperatorForDataType(dataType) {
  const dt = (dataType || 'text').toLowerCase();
  if (['text', 'phone', 'textarea', 'email', 'url'].includes(dt)) {
    return 'contains';
  }
  if (['picklist', 'multipicklist'].includes(dt)) {
    return 'equals';
  }
  if (['lookup', 'reference'].includes(dt)) {
    return 'equals';
  }
  if (['boolean', 'checkbox'].includes(dt)) {
    return 'equals';
  }
  return 'equals';
}

/** Legacy widget configs omit operator — list API used equals. */
export function effectiveFilterBindingOperator(binding) {
  if (
    binding &&
    binding.operator !== undefined &&
    binding.operator !== null &&
    String(binding.operator).length > 0
  ) {
    return binding.operator;
  }
  return 'equals';
}

/** Bindings persisted on search widgets: include if null-check only or field + source. */
export function isPersistableFilterBinding(b) {
  if (!b?.filterable_field) return false;
  const op = effectiveFilterBindingOperator(b);
  if (op === 'is_null' || op === 'is_not_null') return true;
  return Boolean(b.source_field);
}

export function filterBindingRequiresSourceField(operator) {
  return !['is_null', 'is_not_null'].includes(operator || 'equals');
}
